// Footer — social links, email signup, business basics. No merch/product
// links; the homepage funnel points to Get a Quote. Social pills rotate
// through the pan-flag palette for one last visual beat before sign-off.
import PanBar from "../components/PanBar";

// Four socials rotating pink / gold / sky / cream — the pan-flag colors
// plus one warm beat. Bluesky is where pancakes post live off the griddle.
const SOCIAL = [
  { label: "Instagram", href: "https://instagram.com/thejoyofpancakes", tint: { c: "var(--jop-pink)",           bd: "rgba(239,83,126,0.5)", bg: "rgba(239,83,126,0.1)" } },
  { label: "YouTube",   href: "https://youtube.com/@thejoyofpancakes",   tint: { c: "var(--jop-gold)",           bd: "rgba(252,179,31,0.5)", bg: "rgba(252,179,31,0.1)" } },
  { label: "Twitch",    href: "https://twitch.tv/thejoyofpancakes",      tint: { c: "var(--jop-highlight-blue)", bd: "rgba(74,164,225,0.5)", bg: "rgba(74,164,225,0.1)" } },
  { label: "Bluesky",   href: "https://bsky.app/profile/thejoyofpancakes.com", tint: { c: "var(--jop-cream)",    bd: "rgba(255,218,173,0.5)", bg: "rgba(255,218,173,0.1)" } },
];

export default function SiteFooter() {
  return (
    <footer style={{
      background: "#050f18",
      borderTop: "1px solid rgba(252,179,31,0.15)",
      padding: "3rem 1.5rem 2rem",
      color: "rgba(255,218,173,0.7)",
      fontFamily: "var(--jop-display)",
    }}>
      <div style={{
        maxWidth: "1000px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "2rem",
      }}>
        {/* Social */}
        <div>
          <div style={{ color: "var(--jop-gold)", fontWeight: 800, fontSize: "0.82rem", letterSpacing: "0.08em", marginBottom: "0.6rem" }}>FOLLOW ALONG</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem" }}>
            {SOCIAL.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: s.tint.c,
                  textDecoration: "none",
                  padding: "0.3rem 0.75rem",
                  border: `1px solid ${s.tint.bd}`,
                  background: s.tint.bg,
                  borderRadius: "999px",
                  fontSize: "0.82rem",
                  fontWeight: 700,
                  transition: "transform 0.15s ease",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        {/* Email signup (stub — wire to Brevo list or mailto for now) */}
        <div>
          <div style={{ color: "var(--jop-gold)", fontWeight: 800, fontSize: "0.82rem", letterSpacing: "0.08em", marginBottom: "0.6rem" }}>STAY IN THE LOOP</div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const email = e.currentTarget.querySelector("input[name=email]")?.value?.trim();
              if (email) window.location.href = `mailto:hello@thejoyofpancakes.com?subject=Newsletter%20signup&body=Add%20me%20to%20the%20list:%20${encodeURIComponent(email)}`;
            }}
            style={{ display: "flex", gap: "0.4rem", maxWidth: "320px" }}
          >
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              required
              style={{
                flex: 1,
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,218,173,0.25)",
                borderRadius: "8px",
                color: "var(--jop-cream)",
                padding: "0.5rem 0.7rem",
                fontSize: "0.85rem",
                outline: "none",
                fontFamily: "inherit",
              }}
            />
            <button
              type="submit"
              style={{
                background: "var(--jop-gold)",
                color: "#1a0a12",
                border: "none",
                borderRadius: "8px",
                padding: "0.5rem 0.85rem",
                fontWeight: 800,
                fontSize: "0.8rem",
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              Sign up
            </button>
          </form>
        </div>

        {/* Business basics */}
        <div>
          <div style={{ color: "var(--jop-gold)", fontWeight: 800, fontSize: "0.82rem", letterSpacing: "0.08em", marginBottom: "0.6rem" }}>THE BUSINESS</div>
          <div style={{ fontSize: "0.82rem", lineHeight: 1.7 }}>
            Lucky Bean LLC<br />
            Based in St. Louis, MO<br />
            <a href="mailto:hello@thejoyofpancakes.com" style={{ color: "var(--jop-highlight-blue)", textDecoration: "none" }}>hello@thejoyofpancakes.com</a><br />
            <span style={{ opacity: 0.6, fontSize: "0.78rem" }}>Payments via Square · Credit, debit, Cash App, Apple Pay</span>
          </div>
        </div>
      </div>

      <PanBar width={120} height={3} margin="2.5rem auto 1rem" />

      <div style={{
        maxWidth: "1000px",
        margin: "0 auto 0.6rem",
        display: "flex",
        justifyContent: "center",
        gap: "1.4rem",
        flexWrap: "wrap",
        fontSize: "0.78rem",
      }}>
        <a href="/shipping" style={footerLink}>Shipping &amp; Returns</a>
        <a href="/privacy"  style={footerLink}>Privacy Policy</a>
        <a href="/terms"    style={footerLink}>Terms of Service</a>
      </div>

      <div style={{
        maxWidth: "1000px",
        margin: "0 auto",
        paddingTop: "0.5rem",
        fontSize: "0.75rem",
        opacity: 0.6,
        textAlign: "center",
      }}>
        © {new Date().getFullYear()} The Joy of Pancakes · Lucky Bean LLC · thejoyofpancakes.com
      </div>
    </footer>
  );
}

const footerLink = {
  color: "rgba(255,218,173,0.65)",
  textDecoration: "none",
  fontWeight: 600,
};
